import { RobotoTypography } from "@/shared/components/RobotoTypography";

import styles from "./UserMessage.module.css";

interface UserMessageProps {
  /**
   * Text content to display
   */
  text: string;
}

/**
 * Component for rendering user messages.
 * Displays plain text with appropriate styling for the variant.
 */
export function UserMessage({ text }: UserMessageProps) {
  return (
    <div className={styles.indentedContainer}>
      <div className={styles.messageContainer}>
        <RobotoTypography className={styles.text}>{text}</RobotoTypography>
      </div>
    </div>
  );
}
